import * as React from 'react';

import type {
    NavigateBackSideSheetFunction,
    NavigateFunction,
    NavigateGetLocationFunction,
    NavigateURLFunction,
    NavigationState,
} from './types';

export const NavigationStateContext = React.createContext<NavigationState>({
    screen: { type: 'root' },
});

export const NavigationFunctionsContext = React.createContext<{
    forceHardNavigation: boolean;
    navigate: NavigateFunction;
    getNavigationURL: NavigateURLFunction;
    getLocationFor: NavigateGetLocationFunction;
    getNavigationState: () => NavigationState;
    getSideSheetToGoBackTo: NavigateBackSideSheetFunction;
}>({
    forceHardNavigation: false,
    navigate: () => {},
    getNavigationURL: () => '',
    getLocationFor: () => ({ pathname: '' }),
    getNavigationState: () => ({ screen: { type: 'root' } }),
    getSideSheetToGoBackTo: () => null,
});
